import RegisterEndorsementProvider from '../providers/register-endorsement-provider';

class RegisterEndorsementRepository {

    constructor() {
        this.registerEndorsementProvider = new RegisterEndorsementProvider();
    }

    postValidarEndosoPoliza = async (datosPoliza) => {
        return this.registerEndorsementProvider.registrarSolicitudEndoso(datosPoliza);
    }

}

export default RegisterEndorsementRepository;